import React from "react";
import { NavLink } from "react-router-dom";

const tabs = [
  { to: "/home", label: "Home", icon: "🏠" },
  { to: "/species", label: "Species", icon: "🌿" },
  { to: "/report", label: "Report", icon: "📍" },
  { to: "/awareness", label: "Aware", icon: "🎓" },
  { to: "/ai-detect", label: "AI", icon: "🤖" },
  { to: "/reports", label: "DSS", icon: "📊" },
  { to: "/login", label: "Admin", icon: "🔐" },
];

export default function MobileTabBar() {
  return (
    <nav className="mobile-tabbar" aria-label="Main Navigation">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            `mobile-tab-item${isActive ? " active" : ""}`
          }
        >
          <span className="mobile-tab-icon">{tab.icon}</span>
          <span className="mobile-tab-label">{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
